// components/ChatbotDemo.js
import React, { useEffect } from "react";
import { createChat } from "@n8n/chat";
// import "@n8n/chat/style.css";
// import "../styles/ChatbotTheme.css"; // Optional
import Header from "./Header";
import "../styles/ChatbotThemeDemo.css"; // Optional
import { Helmet } from "react-helmet";

const ChatbotDemo = ({
  webhookUrl,
  branding,
  initialMessages,
  i18n,
  clientName,
  headline = "Automate, Optimize, and Grow with DataPulse!",
  subtext = `Book a FREE Discovery call to explore how automation can transform your company!`,
}) => {
  useEffect(() => {
    // First chatbot - fullscreen
    createChat({
      webhookUrl,
      webhookConfig: {
        method: 'POST',
      },
      branding,
      target: "#chatbot_fullscreen",
      mode: "fullscreen",
      chatInputKey: "chatInput",
      chatSessionKey: "sessionId",
      metadata:{},
      showWelcomeScreen: false,
      defaultLanguage: "en",
      initialMessages,
      i18n,
    });
  }, [webhookUrl, branding, initialMessages, i18n]);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "#", label: "Get in touch" },
  ];


  return (
    <>
      <Header links={navLinks} />
      <Helmet>
        {/* Title and Meta Description */}
        <title>{clientName} Demo | DataPulse AI</title>
        <meta name="title" content="{clientName} Demo | DataPulse AI" />
        <meta name="description" content="Try the DataPulse AI chatbot live - see how it can automate, assist, and convert for your business." />
        <link rel="canonical" href="https://www.mydatapulse.co.uk/chatbot-demo" />

        {/* Open Graph */}
        <meta property="og:site_name" content="DataPulse AI" />
        <meta property="og:title" content="{clientName} Demo | DataPulse AI" />
        <meta property="og:description" content="Experience the power of AI in action with our chatbot demo - helping businesses automate and grow smarter." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mydatapulse.co.uk/chatbot-demo" />
        <meta property="og:image" content="https://www.mydatapulse.co.uk/icons/logo-clean-large.png" />
        <meta property="og:image:alt" content="DataPulse AI chatbot demo preview" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="{clientName} Demo | DataPulse AI" />
        <meta name="twitter:description" content="Try the DataPulse AI chatbot - your personalised, automated assistant for business growth." />
        <meta name="twitter:image" content="https://www.mydatapulse.co.uk/icons/logo-clean-large.png" />
        <meta name="twitter:image:alt" content="DataPulse AI chatbot demo preview" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "AI Chatbot Demo | DataPulse AI",
            "url": "https://www.mydatapulse.co.uk/chatbot-demo",
            "description": "Live chatbot demo from DataPulse AI. Automate, engage, and convert with our intelligent assistant.",
            "publisher": {
              "@type": "Organization",
              "name": "DataPulse AI",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.mydatapulse.co.uk/icons/logo-clean-large.png"
              }
            }
          })}
        </script>
      </Helmet>
      <main>
        <section className="bg-white dark:bg-gray-900">
          <div className="max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:pt-28">
            <div className="mr-auto place-self-center">
              <div className="max-w-screen-sm mx-auto text-center">
                <h1 className="mb-10 text-5xl font-extrabold leading-tight tracking-tight text-purple-600 dark:text-white">
                  {clientName} x DataPulse
                </h1>
                <h2 className="mb-10 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
                  {headline}
                </h2>
                <span className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
                  {subtext}
                </span>
                <br/>
                <br/>
                <div className="flex text-left"
                    id="chatbot_fullscreen"
                    style={{
                      position: "relative",
                      height: "50vh",
                      zIndex: 1,
                    }}/>
                </div>
              </div>
            </div>
        </section>
      </main>
    </>
  );
};

export default ChatbotDemo;
